import AuthenticatedLayout from './AuthenticatedLayout';
import { useAuth } from '@/auth/useAuth';
import { Container } from '@/components/Container';
import { Fragment } from 'react/jsx-runtime';
import { SiteFooter } from './components/SiteFooter';
import { AppHead } from '@/pages/components/AppHead';
import { TopNavigationBar } from './components/TopNavigationBar';
import { Link } from '@inertiajs/react';
import { Button } from '@/trailmix/Button';

type AppLayoutProps = {
    children: React.ReactNode;
    withContainer?: boolean;
};

export function AppLayout({ children, withContainer = true }: AppLayoutProps) {
    const auth = useAuth();

    const ContentWrapper = withContainer ? Container : Fragment;

    if (!auth.user) {
        return (
            <div className='flex min-h-screen flex-col'>
                <AppHead />
                <TopNavigationBar
                    left={<></>}
                    right={
                        <>
                            <div className='flex gap-2'>
                                <Button as={Link} href={route('login')} size='sm' variant='secondary'>
                                    Login
                                </Button>
                                <Button as={Link} href={route('register')} size='sm' variant='primary'>
                                    Sign Up
                                </Button>
                            </div>
                        </>
                    }
                />
                <ContentWrapper>{children}</ContentWrapper>
                <SiteFooter />
            </div>
        );
    }
    return (
        <AuthenticatedLayout>
            <ContentWrapper>{children}</ContentWrapper>
        </AuthenticatedLayout>
    );
}
